import React, { useEffect, useState } from 'react'
import ProductCard from './productCard'

import filterProducts from './filter'

const CollectionProducts = ({ collection, filter, isShowAll }) => {
  const [products, setProducts] = useState(collection.products)
  const [tempProducts, setTempProducts] = useState(collection.products)

  useEffect(() => {
    if (!isShowAll) {
      const items = collection.products.slice(0, 5)
      setProducts(items)
    } else {
      setProducts(collection.products)
    }
    setTempProducts(collection.products)
  }, [collection, isShowAll])

  useEffect(() => {
    if (tempProducts && filter) {
      if (filter.size || filter.color) {
        const results = filterProducts(tempProducts, filter)
        setProducts(results)
      }
    }
  }, [filter])

  return (
    <div className='collection-section'>
      <p className='title'>{collection.title}</p>
      {products && products.length > 0 ? (
        <div className='products-grid'>
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              collection={collection}
            />
          ))}
          {!isShowAll && tempProducts.length > 5 && (
            <div className='product-card'>
              <a
                className='link-shop-collections'
                href={`/collections/${collection.handle}`}
              >
                Shop all {collection.title} >
              </a>
            </div>
          )}
        </div>
      ) : (
        <div>
          <p>No products found.</p>
        </div>
      )}
    </div>
  )
}

export default CollectionProducts
